import { useLayoutEffect, useState } from 'react'

import { useGuideTour } from '../provider/guideTourContext'
import { GUIDE_TOUR_ACTIVATION_LOADING_MESSAGE } from '../utils/tourRuntime'
import {
  getGuideTourStepCardEstimatedHeight,
  getGuideTourStepCardWidth,
  getScreenStepCardPosition,
} from './utils'
import * as S from './styles'

export const GuideTourActivationLoadingCard = () => {
  const { isGuideTourActivationPending, state } = useGuideTour()
  const [position, setPosition] = useState({ top: 0, left: 0 })

  const isVisible = isGuideTourActivationPending && state.status !== 'active'

  useLayoutEffect(() => {
    if (!isVisible) {
      return
    }

    const cardWidth = Math.min(
      getGuideTourStepCardWidth('small'),
      window.innerWidth - 32
    )
    const cardHeight = getGuideTourStepCardEstimatedHeight('small')

    setPosition(
      getScreenStepCardPosition({
        cardWidth,
        cardHeight,
        viewportWidth: window.innerWidth,
        viewportHeight: window.innerHeight,
      })
    )
  }, [isVisible])

  if (!isVisible) {
    return null
  }

  return (
    <S.Card
      $cardSize="small"
      data-testid="guide-tour-activation-loading"
      role="status"
      aria-live="polite"
      aria-busy="true"
      style={{ top: position.top, left: position.left }}
    >
      <S.CardInner $cardSize="small">
        <S.ActivationLoadingInner>
          <S.ActivationSpinner aria-hidden />
          <S.ActivationLoadingMessage>
            {GUIDE_TOUR_ACTIVATION_LOADING_MESSAGE}
          </S.ActivationLoadingMessage>
        </S.ActivationLoadingInner>
      </S.CardInner>
    </S.Card>
  )
}
